module.exports = __webpack_public_path__ + "img/SS_V_Basic_Lightning.11fa0557.png";